import Link from "next/link";
import React, { ReactElement } from "react";
import { type IWordpress } from "../../interfaces";
import { useTranslation } from "next-i18next";
import styles from "./blogPostCard.module.scss";
import { Text } from "@kunduz/ui-atoms";
import { blue, gray } from "@kunduz/ui-components";

export const BlogPostCard = (props: Props): ReactElement => {
  const { t } = useTranslation("kunduzcom_blog");

  function calculatePostUrl() {
    if (props.lang == "en") {
      return `/blog/${props.post.slug}-${props.post.postId}/`;
    } else {
      return `/tr/blog/${props.post.slug}-${props.post.postId}/`;
    }
  }

  return (
    <div className={styles.card}>
      <div className={styles.imageWrapper}>
        <img
          src={props.post.featuredImage?.node?.sourceUrl}
          alt={props.post.title}
          loading="lazy"
        />
      </div>
      <div className={styles.content}>
        <Text variant="textsm" weight="semibold" style={{ color: blue[600] }}>
          {props.post.categories.nodes.at(0)?.name}
        </Text>

        <div className={styles.headingAndText}>
          <Link className={styles.title} href={calculatePostUrl()}>
            <h2>{props.post.title}</h2>
          </Link>
          <Text variant="textsm" style={{ color: gray[600] }}>
            {props.post.excerpt}
          </Text>
        </div>
      </div>
    </div>
  );
};

interface Props {
  post: IWordpress.IWordpressCategoryPostResponse["nodes"][0];
  lang: "tr" | "en";
}
